package com.htmlagent.site.i18n

// Generated from i18n/strings.json. Do not edit: edit the JSON and rebuild.

/** The texts of the rail area. */
interface RailStrings {
    val newSession: String

    val conversation: String

    val history: String

    val switchToDark: String

    val switchToLight: String

    val switchToSpanish: String

    val switchToEnglish: String

    val navLabel: String

    val switchUser: String

    val startMenu: String

    val startBlank: String

    val startBlankHint: String

    val startGuided: String

    val startGuidedHint: String

    val backToLanding: String

    val chatTab: String

    val pageTab: String

    val language: String

    val theme: String

    val lightMode: String

    val darkMode: String

    val autoMode: String
}

/** The rail area in Spanish. */
internal object SpanishRailStrings : RailStrings {
    override val newSession: String = "Empezar una sesión nueva"

    override val conversation: String = "Conversación"

    override val history: String = "Tus sesiones anteriores"

    override val switchToDark: String = "Cambiar a modo oscuro"

    override val switchToLight: String = "Cambiar a modo claro"

    override val switchToSpanish: String = "Cambiar a español"

    override val switchToEnglish: String = "Cambiar a inglés"

    override val navLabel: String = "Navegación de la aplicación"

    override val switchUser: String = "Cambiar de usuario"

    override val startMenu: String = "Empezar algo nuevo"

    override val startBlank: String = "En blanco"

    override val startBlankHint: String = "Escribo yo lo que quiero"

    override val startGuided: String = "Con el asistente"

    override val startGuidedHint: String = "Cuatro preguntas y lo escribe por mí"

    override val backToLanding: String = "Volver a la página de HAL"

    override val chatTab: String = "Chat"

    override val pageTab: String = "Página"

    override val language: String = "Idioma"

    override val theme: String = "Tema"

    override val lightMode: String = "Claro"

    override val darkMode: String = "Oscuro"

    override val autoMode: String = "Auto"
}

/** The rail area in English. */
internal object EnglishRailStrings : RailStrings {
    override val newSession: String = "Start a new session"

    override val conversation: String = "Conversation"

    override val history: String = "Your previous sessions"

    override val switchToDark: String = "Switch to dark mode"

    override val switchToLight: String = "Switch to light mode"

    override val switchToSpanish: String = "Switch to Spanish"

    override val switchToEnglish: String = "Switch to English"

    override val navLabel: String = "Application navigation"

    override val switchUser: String = "Switch user"

    override val startMenu: String = "Start something new"

    override val startBlank: String = "Blank"

    override val startBlankHint: String = "I write what I want"

    override val startGuided: String = "With the assistant"

    override val startGuidedHint: String = "Four questions and it writes it for me"

    override val backToLanding: String = "Back to the HAL page"

    override val chatTab: String = "Chat"

    override val pageTab: String = "Page"

    override val language: String = "Language"

    override val theme: String = "Theme"

    override val lightMode: String = "Light"

    override val darkMode: String = "Dark"

    override val autoMode: String = "Auto"
}
